import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMessageQuestion } from "@fortawesome/sharp-regular-svg-icons";
import { useHelpScout } from "../../../../hooks/useHelpScout";
import styles from "./HelpButton.module.scss";

export default function HelpButton() {
  const { toggleBeacon } = useHelpScout();

  return (
    <button
      className={styles.helpButton}
      onClick={toggleBeacon}
      type="button"
      aria-label="toggle help"
    >
      <FontAwesomeIcon icon={faMessageQuestion} className={styles.icon} />
    </button>
  );
}
